import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginUser } from '../../api/auth';
import LoginForm from '../../common/LoginForm';

class Login extends Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
  }

  login(credentials) {
    this.props.login(credentials);
  }

  render() {
    return (
      <div>
        <LoginForm handler={this.login} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (credentials) => dispatch(loginUser(credentials))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js